import React from 'react';
import {
	Button,
	Card,
	Col,
	Container,
	Form,
	FormControl,
	ListGroup,
	Row,
} from 'react-bootstrap';
import Modal from "../common/components/ThemedModal";
import {
	createSeries,
	createSport,
	getSeries,
	getSports,
	updateSport,
} from '../../services/series';
import { useEffect } from 'react';
import AdminLayout from './AdminLayout';

const AdminSportsPage = () => {
	const [series, setSeries] = React.useState('');
	const [seriesDescription, setSeriesDescription] = React.useState('');
	const [sport, setSport] = React.useState('');
	const [sportShortName, setSportShortName] = React.useState('');
	const [sportDescription, setSportDescription] = React.useState('');
	const [seriesList, setSeriesList] = React.useState([]);
	const [sports, setSports] = React.useState([]);
	const [editSportId, setEditSportId] = React.useState('');
	const [editSportName, setEditSportName] = React.useState('');
	const [editSportShortName, setEditSportShortName] = React.useState('');
	const [editSportDescription, setEditSportDescription] = React.useState('');
	const [showEditSportModal, setShowEditSportModal] = React.useState(false);
	useEffect(() => {
		getAllSeries();
		getAllSports();
	}, []);

	const getAllSeries = async () => {
		try {
			const res = await getSeries();
			if (res) {
				setSeriesList(res.data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getAllSports = async () => {
		try {
			const res = await getSports();
			if (res) {
				setSports(res.data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const createNewSeries = async () => {
		try {
			const data = {
				name: series,
				description: seriesDescription,
			};
			const res = await createSeries(data);
			if (res) {
				//clear the state
				setSeries('');
				setSeriesDescription('');
				getAllSeries();
			}
		} catch (error) {
			console.log(error);
		}
	};

	const createNewSport = async () => {
		try {
			const data = {
				name: sport,
				shortName: sportShortName,
				description: sportDescription,
			};
			const res = await createSport(data);
			if (res) {
				//clear the state
				setSport('');
				setSportShortName('');
				setSportDescription('');
				getAllSports();
			}
		} catch (error) {
			console.log(error);
		}
	};

	const startEditSport = (sportItem) => {
		setEditSportId(sportItem._id || sportItem.id || '');
		setEditSportName(sportItem.name || '');
		setEditSportShortName(sportItem.shortName || '');
		setEditSportDescription(sportItem.description || '');
		setShowEditSportModal(true);
	};

	const cancelEditSport = () => {
		setEditSportId('');
		setEditSportName('');
		setEditSportShortName('');
		setEditSportDescription('');
		setShowEditSportModal(false);
	};

	const saveSportUpdates = async () => {
		try {
			if (!editSportId) {
				return;
			}

			const data = {
				name: editSportName,
				shortName: editSportShortName,
				description: editSportDescription,
			};

			const res = await updateSport(editSportId, data);
			if (res) {
				cancelEditSport();
				getAllSports();
			}
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<AdminLayout>
			<Container className='pt-3 admin-sports-page'>
				<div className='d-flex flex-row alignt-items-center justify-content-center py-4'>
					<h1>Sports & Series </h1>
				</div>
				<Row>
					<Col>
						<Card>
							<Card.Body>
								<Card.Title>Current Sports</Card.Title>
								<ListGroup>
									{sports.map((sport, index) => (
										<ListGroup.Item
											key={index}
											className='d-flex justify-content-between align-items-center gap-2'
										>
											<div>
												<div className='fw-bold'>{sport.name}</div>
												<small className='text-muted'>
													Short Name: {sport.shortName || '-'}
												</small>
											</div>
											<Button
												type='button'
												size='sm'
												variant='outline-primary'
												onClick={() => startEditSport(sport)}
											>
												Edit
											</Button>
										</ListGroup.Item>
									))}
								</ListGroup>
							</Card.Body>
						</Card>
					</Col>
					<Col>
						<Card>
							<Card.Body>
								<Card.Title>Current Series</Card.Title>
								<ListGroup>
									{seriesList.map((series, index) => (
										<ListGroup.Item key={index}>{series.name}</ListGroup.Item>
									))}
								</ListGroup>
							</Card.Body>
						</Card>
					</Col>
				</Row>

				<Card className='mt-4'>
					<Card.Body>
					<Card.Title>Create a New Sport</Card.Title>
					<Form className='mb-3'>
						<Form.Group controlId='formBasicEmail'>
							<Form.Label>Sport Name</Form.Label>
							<FormControl
								type='text'
								placeholder='Enter sport name'
								value={sport}
								onChange={(e) => setSport(e.target.value)}
							/>
						</Form.Group>
						<Form.Group controlId='sportShortName'>
							<Form.Label>Short Name</Form.Label>
							<FormControl
								type='text'
								placeholder='Enter short name'
								value={sportShortName}
								onChange={(e) => setSportShortName(e.target.value)}
							/>
						</Form.Group>
						<Form.Group controlId='formBasicEmail'>
							<Form.Label>Description</Form.Label>
							<FormControl
								as='textarea'
								placeholder='Enter description'
								value={sportDescription}
								onChange={(e) => setSportDescription(e.target.value)}
							/>
						</Form.Group>
					</Form>
					<Card.Footer
						className='d-flex flex-row align-items-end justify-content-end'
					>
						<Button variant='primary' className='' onClick={createNewSport}>
							Create Sport
						</Button>
					</Card.Footer>
				</Card.Body>
			</Card>
			{/* // Create a new Series */}
			<Card className='mt-4'>
				<Card.Body>
					<Card.Title>Create a New Series</Card.Title>
					<Form className='mb-3'>
						<Form.Group controlId='formBasicEmail'>
							<Form.Label>Series Name</Form.Label>
							<FormControl
								type='text'
								placeholder='Enter series name'
								value={series}
								onChange={(e) => setSeries(e.target.value)}
							/>
						</Form.Group>
						<Form.Group controlId='formBasicEmail'>
							<Form.Label>Description</Form.Label>
							<FormControl
								as='textarea'
								placeholder='Enter description'
								value={seriesDescription}
								onChange={(e) => setSeriesDescription(e.target.value)}
							/>
						</Form.Group>
					</Form>
					<Card.Footer
						className='d-flex flex-row align-items-end justify-content-end'
					>
						<Button variant='primary' className='' onClick={createNewSeries}>
							Create Series
						</Button>
					</Card.Footer>
				</Card.Body>
				</Card>
				<Modal
					show={showEditSportModal}
					onHide={cancelEditSport}
					centered
					
				>
					<Modal.Header closeButton>
						<Modal.Title>Edit Sport</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Form className='mb-1'>
							<Form.Group controlId='editSportName'>
								<Form.Label>Sport Name</Form.Label>
								<FormControl
									type='text'
									placeholder='Enter sport name'
									value={editSportName}
									onChange={(e) => setEditSportName(e.target.value)}
								/>
							</Form.Group>
							<Form.Group controlId='editSportShortName'>
								<Form.Label>Short Name</Form.Label>
								<FormControl
									type='text'
									placeholder='Enter short name'
									value={editSportShortName}
									onChange={(e) => setEditSportShortName(e.target.value)}
								/>
							</Form.Group>
							<Form.Group controlId='editSportDescription'>
								<Form.Label>Description</Form.Label>
								<FormControl
									as='textarea'
									placeholder='Enter description'
									value={editSportDescription}
									onChange={(e) => setEditSportDescription(e.target.value)}
								/>
							</Form.Group>
						</Form>
					</Modal.Body>
					<Modal.Footer>
						<Button variant='outline-secondary' onClick={cancelEditSport}>
							Cancel
						</Button>
						<Button
							variant='primary'
							onClick={saveSportUpdates}
							disabled={!editSportId}
						>
							Save Sport
						</Button>
					</Modal.Footer>
				</Modal>
		</Container>
	</AdminLayout>
	);
};

export default AdminSportsPage;
